export default function PencilUnderline({ className = '' }) {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M1.39984 15H12.5997" stroke="currentColor" strokeWidth="1.04" strokeLinecap="round" />
      <path
        d="M8.32139 2.16428L8.84078 1.64488C9.04531 1.4404 9.28812 1.2782 9.55533 1.16755C9.82255 1.0569 10.1089 0.999968 10.3982 1C10.6874 1.00003 10.9738 1.05703 11.2409 1.16774C11.5081 1.27845 11.7509 1.4407 11.9554 1.64523C12.1599 1.84976 12.3221 2.09257 12.4327 2.35978C12.5434 2.627 12.6003 2.91339 12.6003 3.20261C12.6002 3.49183 12.5432 3.77821 12.4325 4.0454C12.3218 4.31259 12.1596 4.55536 11.955 4.75984L11.4356 5.27784M11.4356 5.27854L6.66381 10.0504C6.34041 10.3738 6.17941 10.5348 6.00092 10.6741C5.79092 10.8379 5.56342 10.9786 5.32262 11.0934C5.11893 11.1907 4.90193 11.2628 4.46863 11.407L2.63046 12.0202M8.32139 2.16358L3.54955 6.93612C3.22615 7.25951 3.06445 7.42051 2.92585 7.59901C2.76185 7.8092 2.62126 8.03664 2.50656 8.2773C2.40926 8.481 2.33716 8.698 2.19226 9.13129L1.57977 10.9695M1.57977 10.9695L1.43067 11.4182C1.39572 11.5228 1.39061 11.6351 1.41592 11.7424C1.44123 11.8498 1.49595 11.948 1.57394 12.026C1.65194 12.104 1.75013 12.1587 1.85749 12.184C1.96485 12.2093 2.07714 12.2042 2.18176 12.1693L2.63046 12.0202M1.57977 10.9695C1.57977 10.9695 1.50225 11.6024 1.74991 11.85C1.99757 12.0977 2.63046 12.0202 2.63046 12.0202"
        stroke="currentColor"
        strokeWidth="1.04"
      />
    </svg>
  );
}
